import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const productsFields: FieldInterface[] = [
  {
    key: 'name',
    originKey: 'name',
    type: FIELD_TYPES.string,
  },
  {
    key: 'productKind',
    originKey: 'product_kind',
    type: FIELD_TYPES.string,
  },
  {
    key: 'data',
    originKey: 'data',
    type: FIELD_TYPES.object,
    objectType: 'WealthRecommendationProductData',
    objectTypePath: 'src/global-types',
  },
]

const productsRelations: RelationInterface[] = [
  {
    key: '_ownedProductInvestments',
    originKey: 'owned_product_investments',
    objectType: OBJECT_TYPES.productInvestments,
    isMultiple: true,
  },
]

export { productsFields, productsRelations }
